import { TooltipProps } from "@mui/material/Tooltip";
import React from "react";

import { InfoIcon } from "components/Icons";
import Tooltip from "components/Tooltip";

import styles from "../../ContextSelector.module.scss";

type PropsTooltip = {
  title: React.ReactNode;
  placement?: TooltipProps["placement"];
};

export const EngineItemInfo = ({ title, placement }: PropsTooltip) => {
  return (
    <Tooltip
      onClick={e => e.stopPropagation()}
      title={title}
      placement={placement ?? "right"}
      arrow
      classes={{ tooltip: styles.tooltip }}
    >
      <div data-testid="engine-item-info-icon">
        <InfoIcon className={styles.infoIcon} />
      </div>
    </Tooltip>
  );
};
